<!-- 注册审批 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             :rules="dataRule"
             ref="dataForm">
      <div class="location-layout">
        <div class="reg-img">
          <img alt="" :src='dataForm.headurl' />
        </div>
        <el-row class="row-mar-l">
          <!-- 姓名 -->
          <el-col :span="6"
                  :offset="6">
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 姓的拼音 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.firstname')">
              <el-input v-model="dataForm.lastName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 名的拼音 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.lastname')">
              <el-input v-model="dataForm.firstName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 证件类型 -->
          <el-col :span="6"
                  :offset="6">
            <el-form-item :label="$t('user.idtype')">
              <el-select v-model="dataForm.idType"
                         :placeholder="$t('user.idtype')"
                         :disabled="true">
                <el-option v-for="(item,index) in idTypeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 证件编号 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.passportIdcard')">
              <el-input v-model="dataForm.idcard"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 出生日期 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.dateofbirth')">
              <el-date-picker v-model="dataForm.birthday"
                              type="date"
                              :disabled="true"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 性别 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.gender')">
              <el-select v-model="dataForm.sexCode"
                         :disabled="true">
                <el-option v-for="(item,index) in sexCode"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 手机 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.mobile')">
              <el-input v-model="dataForm.mobile"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 邮箱 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.userEmail')">
              <el-input v-model="dataForm.email"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 最高学历 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.education')">
              <el-select v-model="dataForm.educationCode"
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in educationCode"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 组织类型 -->
          <el-col :span="6">
            <el-form-item :label="$t('organization.orgType')">
              <el-select v-model="dataForm.orgType"
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in userorgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所属组织 -->
          <el-col :span="6">
            <!-- 经销商 -->
            <el-form-item :label="$t('user.affiliatedDeale')"
                          v-if="dataForm.orgType === '50' || dataForm.orgType === '60'">
              <el-input v-model="dataForm.orgName"
                        :disabled="true"></el-input>
            </el-form-item>
            <!-- 宝马集团 -->
            <el-form-item :label="$t('user.affiliatedGroup')"
                          v-else-if="dataForm.orgType === '10'">
              <el-input v-model="dataForm.orgName"
                        :disabled="true"></el-input>
            </el-form-item>
            <!-- 合作伙伴 -->
            <el-form-item :label="$t('user.affiliatedPartner')"
                          v-else-if="dataForm.orgType === '20'">
              <el-input v-model="dataForm.orgName"
                        :disabled="true"></el-input>
            </el-form-item>
            <!-- 合作院校 -->
            <el-form-item :label="$t('user.affiliatedCollege')"
                          v-else-if="dataForm.orgType === '30'">
              <el-input v-model="dataForm.orgName"
                        :disabled="true"></el-input>
            </el-form-item>
            <!-- 经销商集团 -->
            <el-form-item :label="$t('user.affiliatedDealerGroup')"
                          v-else-if="dataForm.orgType === '40'">
              <el-input v-model="dataForm.orgName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- 紧急联系人及联系方式 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.emergencyContact')"
                          prop="emergencyContactInfo">
              <el-input v-model="dataForm.emergencyContactInfo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <!-- 宝马集团 -->
        <div v-if="dataForm.orgType === '10'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="true"
                                :editable='false'>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 部门 -->
              <el-form-item :label="$t('user.department')"
                            prop="bmwDeptCode">
                <el-input v-model="dataForm.bmwDeptCode"
                          :placeholder="$t('user.departmentInput')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-input v-model="dataForm.positionName"
                            :disabled="true"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
          </el-row>
        </div>

        <!-- 合作伙伴 -->
        <div v-if="dataForm.orgType === '20'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="true"
                                :editable='false'>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-input v-model="dataForm.positionName"
                            :disabled="true"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 合作院校 -->
        <div v-if="dataForm.orgType === '30'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="true"
                                :editable='false'>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-input v-model="dataForm.positionName"
                            :disabled="true"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 经销商集团 -->
        <div v-if="dataForm.orgType === '40'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :disabled="true"
                                :editable='false'>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-input v-model="dataForm.positionName"
                            :disabled="true"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 经销商 -->
        <div v-if="dataForm.orgType === '50' || dataForm.orgType === '60'">
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 宝龄 -->
              <el-form-item :label="$t('user.BMWtime')"
                            prop="bmwSeniority">
                <el-input v-model="dataForm.bmwSeniority"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 所属经销商网点 -->
              <el-form-item :label="$t('user.outlet')"
                            prop="orgId">
                <el-input v-model="dataForm.orgName"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入当前公司日期 -->
              <el-form-item :label="$t('user.accessionDate')"
                            prop="orgJoinDate">
                <el-date-picker v-model="dataForm.orgJoinDate"
                                type="date"
                                value-format="yyyy-MM-dd 00:00:00"
                                :placeholder="$t('user.accessionDateSelect')"
                                :disabled="true"
                                :editable='false'>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 所属BBA No -->
              <el-form-item :label="$t('user.bbaNo')"
                            prop="bbaNo">
                <el-input v-model="dataForm.bbaNo"
                          :placeholder="$t('organization.orgCodeBring')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 所属品牌 -->
              <el-form-item :label="$t('user.brandCodes')">
                <el-select v-model="dataForm.brandCode"
                           :disabled="true"
                           :placeholder="$t('organization.orgCodeBring')">
                  <el-option v-for="(item,index) in brandCodeArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 所属NSC No -->
              <el-form-item :label="$t('user.nscno')"
                            prop="">
                <el-input v-model="dataForm.nscNo"
                          :placeholder="$t('organization.orgCodeBring')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 网点类型 -->
              <el-form-item :label="$t('user.outletType')"
                            prop="">
                <el-input v-model="dataForm.networkType"
                          :placeholder="$t('organization.orgCodeBring')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 主要职位 -->
              <el-form-item :label="$t('user.position')"
                            prop="jobCode">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.jobCode || dataForm.jobCode === ''">
                  <div slot="content"
                       v-html="jobCodeContent"></div>
                  <el-input v-model="dataForm.positionName"
                            :disabled="true"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 当前岗龄 -->
              <el-form-item :label="$t('user.jobyear')"
                            prop="loginFlag">
                <el-input v-model="dataForm.jobcodeAge"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入该职位日期 -->
              <el-form-item :label="$t('user.joinjobdate')"
                            prop="jobcodeJoinDate">
                <el-date-picker v-model="dataForm.jobcodeJoinDate"
                                type="date"
                                :disabled="true"
                                :placeholder="$t('organization.orgCodeBring')">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职1所属网点 -->
              <el-form-item :label="$t('user.outlet1')"
                            prop="partTimeOutletOne">
                <el-input v-model="dataForm.partTimeOutletOneName"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeBring')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位1 -->
              <el-form-item :label="$t('user.parttimejob1')">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeOne || dataForm.partTimeJobcodeOne === ''">
                  <div slot="content"
                       v-html="jobCodeContentOne"></div>
                  <el-input v-model="dataForm.partTimeJobOneName"
                            :disabled="true"
                            :placeholder="$t('organization.orgCodeBring')"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职1日期 -->
              <el-form-item :label="$t('user.joinparttimejob1')"
                            prop="jobcodeJoinDateOne">
                <el-date-picker v-model="dataForm.jobcodeJoinDateOne"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点2 -->
              <el-form-item :label="$t('user.outlet2')"
                            prop="partTimeOutletTwo">
                <el-input v-model="dataForm.partTimeOutletTwoName"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeBring')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位2 -->
              <el-form-item :label="$t('user.parttimejob2')"
                            prop="partTimeJobcodeTwo">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeTwo || dataForm.partTimeJobcodeTwo === ''">
                  <div slot="content"
                       v-html="jobCodeContentTwo"></div>
                  <el-input v-model="dataForm.partTimeJobTwoName"
                            :disabled="true"
                            :placeholder="$t('organization.orgCodeBring')"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职2日期 -->
              <el-form-item :label="$t('user.joinparttimejob2')"
                            prop="jobcodeJoinDateTwo">
                <el-date-picker v-model="dataForm.jobcodeJoinDateTwo"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点3 -->
              <el-form-item :label="$t('user.outlet3')"
                            prop="partTimeOutletThree">
                <el-input v-model="dataForm.partTimeOutletThreeName"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeBring')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位3 -->
              <el-form-item :label="$t('user.parttimejob3')"
                            prop="partTimeJobcodeThree">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeThree || dataForm.partTimeJobcodeThree === ''">
                  <div slot="content"
                       v-html="jobCodeContentThree"></div>
                  <el-input v-model="dataForm.partTimeJobThreeName"
                            :disabled="true"
                            :placeholder="$t('organization.orgCodeBring')"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职3日期 -->
              <el-form-item :label="$t('user.joinparttimejob3')"
                            prop="jobcodeJoinDateThree">
                <el-date-picker v-model="dataForm.jobcodeJoinDateThree"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点4 -->
              <el-form-item :label="$t('user.outlet4')"
                            prop="partTimeOutletFour">
                <el-input v-model="dataForm.partTimeOutletFourName"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeBring')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位4 -->
              <el-form-item :label="$t('user.parttimejob4')"
                            prop="partTimeJobcodeFour">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeFour || dataForm.partTimeJobcodeFour === ''">
                  <div slot="content"
                       v-html="jobCodeContentFour"></div>
                  <el-input v-model="dataForm.partTimeJobFourName"
                            :disabled="true"
                            :placeholder="$t('organization.orgCodeBring')"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职4日期 -->
              <el-form-item :label="$t('user.joinparttimejob4')"
                            prop="jobcodeJoinDateFour">
                <el-date-picker v-model="dataForm.jobcodeJoinDateFour"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 兼职网点5 -->
              <el-form-item :label="$t('user.outlet5')"
                            prop="partTimeOutletFive">
                <el-input v-model="dataForm.partTimeOutletFiveName"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeBring')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 兼职职位5 -->
              <el-form-item :label="$t('user.parttimejob5')"
                            prop="partTimeJobcodeFive">
                <el-tooltip class="item"
                            effect="dark"
                            placement="right"
                            :disabled="!dataForm.partTimeJobcodeFive || dataForm.partTimeJobcodeFive === ''">
                  <div slot="content"
                       v-html="jobCodeContentFive"></div>
                  <el-input v-model="dataForm.partTimeJobFiveName"
                            :disabled="true"
                            :placeholder="$t('organization.orgCodeBring')"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 加入兼职5日期 -->
              <el-form-item :label="$t('user.joinparttimejob5')"
                            prop="jobcodeJoinDateFive">
                <el-date-picker v-model="dataForm.jobcodeJoinDateFive"
                                type="date"
                                :placeholder="$t('organization.orgCodeBring')"
                                :disabled="true">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <div v-if="this.approval === '1'|| this.approval === 1">
          <el-row class="row-mar-l">
            <el-col :span="12">
              <el-form-item label="">
                <span style="font-size:16px;font-weight:bold">变更前</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="">
                <span style="font-size:16px;font-weight:bold">变更后</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.authType"
                           :disabled="true">
                  <el-option v-for="(item,index) in perClassification"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label=""></el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.targetAuthType"
                           :disabled="true">
                  <el-option v-for="(item,index) in perClassification"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label=""></el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="12"
                    style="text-align:center">
              <!-- 角色 -->
              <el-form-item class="role-div"
                            :label="$t('user.role')"
                            prop=""
                            style="width:90% !important">
                <el-input type="textarea"
                          autosize
                          :rows="4"
                          placeholder=""
                          v-model="dataForm.roleNames"
                          :disabled="true">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    style="text-align:center">
              <!-- 角色 -->
              <el-form-item class="role-div"
                            :label="$t('user.role')"
                            prop=""
                            style="width:90% !important">
                <el-input type="textarea"
                          autosize
                          :rows="4"
                          placeholder=""
                          v-model="dataForm.targetRoleNames"
                          :disabled="true">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="12"
                    style="text-align:center"
                    v-if="this.dataForm.authType ==='10'">
              <el-form-item :label="$t('authApply.fileName')"
                            prop="">
                <el-input v-model="dataForm.effectiveFileName"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    v-if="this.dataForm.authType !=='10'">
              <el-form-item label=""></el-form-item>
            </el-col>
            <el-col :span="6"
                    v-if="this.dataForm.authType !== '10' && this.dataForm.targetAuthType === '10'">
              <el-form-item :label="$t('authApply.fileName')"
                            prop="">
                <el-input v-model="dataForm.fileName"
                          :disabled="true" class="fl-input"
                          @click.native="downloadFile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="this.approval === '0' || this.approval === 0">
          <el-row class="row-mar-l">
            <el-col :span="12">
              <el-form-item label="">
                <span style="font-size:16px;font-weight:bold">变更前</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="">
                <span style="font-size:16px;font-weight:bold">变更后</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.originalAuthType"
                           :disabled="true">
                  <el-option v-for="(item,index) in perClassification"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label=""></el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="authType">
                <el-select v-model="dataForm.targetAuthType"
                           :disabled="true">
                  <el-option v-for="(item,index) in perClassification"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label=""></el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="12"
                    style="text-align:center">
              <!-- 角色 -->
              <el-form-item class="role-div"
                            :label="$t('user.role')"
                            prop=""
                            style="width:90% !important">
                <el-input type="textarea"
                          autosize
                          :rows="4"
                          placeholder=""
                          v-model="dataForm.roleNames"
                          :disabled="true">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    style="text-align:center">
              <!-- 角色 -->
              <el-form-item class="role-div"
                            :label="$t('user.role')"
                            prop=""
                            style="width:90% !important">
                <el-input type="textarea"
                          autosize
                          :rows="4"
                          placeholder=""
                          v-model="dataForm.targetRoleNames"
                          :disabled="true">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="12">
              <el-form-item label=""></el-form-item>
            </el-col>
            <!-- 已上传文件下载-->
            <el-col :span="6"
                    v-if="this.dataForm.originalAuthType !== '10' && this.dataForm.targetAuthType === '10'">
              <el-form-item :label="$t('authApply.fileName')"
                            prop="">
                <el-input v-model="dataForm.fileName"
                          :disabled="true" class="fl-input"
                          @click.native="downloadFile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

    </el-form>
  </el-card>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      dataForm: {
      },
      // 性别
      sexCode: this.enums['sex'],
      // 证件类型
      idTypeList: this.enums['idType'],
      // 学历
      educationCode: this.enums['educationCode'],
      // 组织类型
      userorgType: this.enums['orgType'],
      // 是否正式账号
      regularid: this.enums['confirmState'],
      // 毕业状态
      graduationStatus: this.enums['graduationStatus'],
      // 权限分类
      perClassification: this.enums['perClassification'],
      // 品牌
      brandCodeArr: this.enums['brandCode'],

      userRole: 'taAuthApproval',

      approval: 1,
      // 主要职位信息描述
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 兼职职位描述
      jobCodeNumOne: this.$t('activiti.jobCodeNum'),
      jobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      jobCodeNumThree: this.$t('activiti.jobCodeNum'),
      jobCodeNumFour: this.$t('activiti.jobCodeNum'),
      jobCodeNumFive: this.$t('activiti.jobCodeNum'),
      jobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
    }
  },
  computed: {
    dataRule() {
      return {
      }
    }
  },

  created() {
    // 接收广播
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_UPCOMING, (data) => {
      if (this.$refs.dataForm) {
        this.initialization()
      }
    })
  },
  mounted() {
    this.initialization()
  },
  methods: {
    // 页面初始化
    initialization() {
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
      }
      this.getPerClassification()
      this.dataForm = {}
      if (this.$route.query.approval !== undefined) { // 已办且审批通过需要计算宝龄和岗龄
        this.approval = this.$route.query.approval
      }
      if (this.$route.query.authId !== undefined) {
        this.jobCodeNum = this.$t('activiti.jobCodeNum')
        this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.dataForm.authId = this.$route.query.authId
        if (this.$refs.dataForm) {
          this.$refs['dataForm'].resetFields()
        }
        this.getInfo()
      }
    },
    // 获取不同组织类型的权限分类
    getPerClassification() {
      this.perClassificationPartner = []
      this.perClassificationPartnerInstitution = []
      let perClassification = this.perClassification
      for (let i = 0; i < perClassification.length; i++) {
        if (perClassification[i].code === '10') { // 管理员
          this.perClassificationPartner.push(perClassification[i])
          this.perClassificationPartnerInstitution.push(perClassification[i])
        } else if (perClassification[i].code === '20') { // 普通用户
          this.perClassificationPartner.push(perClassification[i])
          this.perClassificationPartnerInstitution.push(perClassification[i])
        } else if (perClassification[i].code === '40') { // 管理层
          this.perClassificationPartner.push(perClassification[i])
          this.perClassificationPartnerInstitution.push(perClassification[i])
        }
      }
    },
    downloadFile() {
      this.$message({
          message: this.$t('user.authApplyDownloadFileMessage'),
          type: 'info',
          duration: 1000,
      })
      this.$request.downloadBigFile('/sys/commAdminFileManagement/downloadUploadedFile',
      //this.$request.download('/sys/commAdminFileManagement/downloadFile',
        this.dataForm.fileName,
        {
          fileManagementId: this.dataForm.fileManagementId
        },
        null,
        true
      )
    },
    downloadEffectiveFile() {
      this.$message({
          message: this.$t('user.authApplyDownloadFileMessage'),
          type: 'info',
          duration: 1000,
      })
      this.$request.downloadBigFile('/sys/commAdminFileManagement/downloadUploadedFile',
      //this.$request.download('/sys/commAdminFileManagement/downloadFile',
        this.dataForm.effectiveFileName,
        {
          fileManagementId: this.dataForm.effectiveFileManagementId
        },
        null,
        true
      )
    },
    getInfo() {
      this.$request.get(`/sys/commAuthApply/detail/${this.dataForm.authId}`).then((res, total, code, data) => {
        if (res.birthday !== '' && res.birthday !== null) {
          res.birthday = Vue.filter('formatDateNoTime')(res.birthday)
        }

        if (this.approval !== 0 && this.approval !== '0' && res.bmwSeniority !== null && res.bmwSeniority !== undefined) {
          res.bmwSeniority = (res.bmwSeniority / 365).toFixed(2)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
        // 计算宝龄和岗龄
        let joinDate = Vue.filter('theTime')(this.dataForm.jobcodeJoinDate)
        if (!this.dataForm.jobcodeJoinDate) {
          joinDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
        }
        let now = Date.parse(new Date())
        if (this.dataForm.jobStatus === '20') {
          if (this.dataForm.leaveDate && this.dataForm.leaveDate !== '') {
            now = Vue.filter('theTime')(this.dataForm.leaveDate)
          }
        }
        // 时间差
        let dateDeviation = parseInt(Math.abs(now - joinDate) / 1000 / 60 / 60 / 24, 10)
        this.dataForm.jobcodeAge = dateDeviation
        // 计算宝龄
        let currentVersionDate = 0
        let bmwDateDeviation = 0
        // 如果在职
        if (this.dataForm.jobStatus === '10') {
          if (this.dataForm.currentVersionDate) {
            currentVersionDate = Vue.filter('theTime')(this.dataForm.currentVersionDate)
            bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
          } else {
            if (this.dataForm.orgJoinDate) {
              currentVersionDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
              bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
            }
          }
          this.dataForm.bmwSeniority = bmwDateDeviation + Number(this.dataForm.bmwSeniority)
        }
        this.dataForm.bmwSeniority = (this.dataForm.bmwSeniority / 365).toFixed(2)
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.reg-img {
  position: absolute;
  height: 143px;
  width: 19%;
  text-align: left;
}
.reg-img img {
  max-height: 143px;
  max-width: 100%;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 23px 0;
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
.addbutton {
  background-color: white;
  border: none;
}
.addbutton:hover {
  cursor: pointer;
}
.delebutton:hover {
  cursor: not-allowed;
}

.fl-input.is-disabled  .el-input__inner {
  color: blue !important;
  text-decoration:underline;
  cursor:pointer;
}
</style>
